import React, { useCallback, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import { change, formValueSelector } from "redux-form";
import type { ThunkDispatchType } from "src/app/reducers/IMainAppState";
import {
  MERCHANT_MOBILE_VIRTUAL_NUMBER,
  MERCHANT_PROVISIONING_TYPE,
} from "src/merchants/forms/MerchantForm";
import { MerchantFormNumberProvisioningAssign } from "src/merchants/forms/MerchantFormNumberProvisioningAssign";
import { PhoneNoInput } from "src/shared/forms/inputs/PhoneNoInput";
import { RadioInput } from "src/shared/forms/inputs/RadioInputOld";

export interface MerchantFormLongNumberProvisioningProps {
  form: string;
  countryCode: string;
  canEdit?: boolean;
}

export const MerchantFormLongNumberProvisioning = ({
  form,
  countryCode,
  canEdit,
}: MerchantFormLongNumberProvisioningProps) => {
  const selector = formValueSelector(form);
  const isProvisioningEnabled =
    useSelector((state) => selector(state, MERCHANT_PROVISIONING_TYPE)) ===
    "long";
  const mobileVirtualNumber = useSelector((state) =>
    selector(state, MERCHANT_MOBILE_VIRTUAL_NUMBER),
  );
  const dispatch = useDispatch<ThunkDispatchType>();
  const handleNumberAssign = useCallback(
    (no: string) => {
      dispatch(change(form, MERCHANT_MOBILE_VIRTUAL_NUMBER, no));
    },
    [dispatch, form],
  );

  useEffect(() => {
    if (canEdit && !isProvisioningEnabled) {
      dispatch(change(form, MERCHANT_MOBILE_VIRTUAL_NUMBER, ""));
    }
  }, [canEdit, dispatch, form, isProvisioningEnabled]);

  return (
    <>
      {canEdit && (
        <Row>
          <Col sm={12}>
            <RadioInput
              inputID={MERCHANT_PROVISIONING_TYPE}
              label={
                <FormattedMessage id="merchants.form.numberProvisioning.enabled" />
              }
              value="long"
            />
          </Col>
        </Row>
      )}
      {isProvisioningEnabled && (
        <Row className={`mt-3 ${canEdit ? "ml-1" : undefined}`}>
          <Col sm={12}>
            <Row>
              <Col sm={12}>
                <PhoneNoInput
                  inputID={MERCHANT_MOBILE_VIRTUAL_NUMBER}
                  label={
                    <FormattedMessage id="merchants.form.numberProvisioning.mobileVirtualNumber" />
                  }
                  isRequired
                  readOnly
                  validationDisabled={!canEdit}
                />
              </Col>
            </Row>
            {canEdit && (
              <Row>
                <Col sm={12}>
                  <MerchantFormNumberProvisioningAssign
                    countryCode={countryCode}
                    onNumberAssign={handleNumberAssign}
                    disabled={Boolean(mobileVirtualNumber)}
                  />
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      )}
    </>
  );
};
